import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { IntlShape, createIntl } from 'react-intl'

export type BrandTheme = 'carrier' | 'ciat' | 'viessmann'

export interface UiState {
    lang: string
    brandTheme: BrandTheme
    intl: IntlShape
    loading: boolean
}

const initialState: UiState = {
    lang: 'en',
    brandTheme: 'carrier',
    intl: createIntl({
        locale: 'en',
        messages: undefined,
    }),
    loading: false,
}

export const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        changeLang: (state, action: PayloadAction<string>) => {
            state.lang = action.payload
        },
        setBrandTheme: (state, action: PayloadAction<BrandTheme>) => {
            state.brandTheme = action.payload
        },
        changeIntl: (state, action: PayloadAction<IntlShape>) => {
            state.intl = action.payload
            state.loading = false
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload
        },
    },
})

export const selectLang = (state: UiState) => state.lang
export const selectBrandTheme = (state: UiState) => state.brandTheme
export const selectLoading = (state: UiState) => state.loading

export const { changeIntl, changeLang, setLoading, setBrandTheme } = uiSlice.actions
export default uiSlice.reducer
